import { AppDispatch } from "../../index";
import { NewCardPaymentMethod } from "src/common/payment";
import { getAddCardAvailableOperation } from "../operations";
import { getAddCardBehavior } from "src/features/paymentGateways";

export const getAddCardAvailable = (dispatch: AppDispatch, paymentMethod: NewCardPaymentMethod) =>
    getAddCardAvailableOperation.invoke(() => Promise.resolve(!!getAddCardBehavior(paymentMethod)), dispatch);
